/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetSearchLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSearchLimitsRequest = createAction<PayloadData<void>>('GET_SEARCH_LIMITS__GET_SEARCH_LIMITS__REQUEST');
export const getSearchLimitsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_SEARCH_LIMITS__GET_SEARCH_LIMITS__SUCCESS');
export const getSearchLimitsFailure = createAction<PayloadData<Error, void, true>>('GET_SEARCH_LIMITS__GET_SEARCH_LIMITS__FAILURE');

export const getSearchLimitsActions = [
    getSearchLimitsRequest,
    getSearchLimitsSuccess,
    getSearchLimitsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSearchLimits = (config?: GetSearchLimits$Config) => {
    return {
        CALL_API: {
            types: getSearchLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/search-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

